import { Button } from '@components/shadcn-ui/button';
import { CSVDownloadProps, Lead } from 'features/leads/types';
import { Download } from 'lucide-react';


const downloadCSV = ({ data, filename = "data.csv" }: CSVDownloadProps) => {
    if (data.length === 0) return;

    const columns = Object.keys(data[0]).filter(key => typeof data[0][key as keyof Lead] !== 'object') as (keyof Lead)[];
    let csvContent = "";

    csvContent += columns.join(",") + "\n";

    csvContent += data.map(row =>
        columns.map(column => {
            const value = row[column];
            return `"${String(value).replace(/"/g, '""')}"`;
        }).join(",")
    ).join("\n");

    const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
    const link = document.createElement("a");
    link.href = URL.createObjectURL(blob);
    link.setAttribute("download", filename);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
};

const CSVDownloadButton =({ data, filename }: CSVDownloadProps) => {
    return (
        <Button onClick={() => downloadCSV({ data, filename })} size="xl" variant="outline">
            <Download />
        </Button>
    );
};

export default CSVDownloadButton;
